import * as React from "react";

import { Company } from "../../../../domain/model/company";
import { Customer } from "../../../../domain/model/customer";

import styled from "styled-components";
import {
  ConstBorderRound,
  ConstColor,
} from "../../../../config/styles_const/styles_const";
import { OuterURL } from "../../../../config/view_const/outer_url";
import Assets from "../../../assets/img/assets";
import AvatarSmall from "../../atom/avatar/avatar_small";
import BtnOuterLinkCorporateMiddle from "../../atom/btn/btn_outer_link_corporate_middle";
import Paragraph from "../../atom/text/paragraph";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  company: Company | null;
  customer: Customer;
}

export const CustomerInterviewMemoInfo: React.FC<IProps> = (props) => {
  const { company, customer } = props;

  const canCustomerInterviewMemo = true;
  const isMaskedInterviewMemo = !!customer.getInterviewUpdatedAtString();

  const ellipsisWith = 212;
  const [ellipsis, setEllipsis] = React.useState<boolean>(
    customer.interviewMemo.length > ellipsisWith
  );

  return (
    <React.Fragment>
      {canCustomerInterviewMemo
        ? customer.interviewMemo && (
            <>
              <AdminWrapper>
                <AdminAvatar src={Assets.admin_image} />
                <div>
                  <AdminUpdateParagraph bold={true}>
                    {customer.getInterviewUpdatedAtString()} 更新
                  </AdminUpdateParagraph>
                  <Paragraph bold={true}>Libera担当者による面談情報</Paragraph>
                </div>
              </AdminWrapper>
              <AdminMemoWrapper>
                <AdminMemoPadding>
                  <Paragraph>
                    {ellipsis
                      ? `${customer.interviewMemo.slice(0, ellipsisWith)}...`
                      : customer.interviewMemo}
                  </Paragraph>
                </AdminMemoPadding>
              </AdminMemoWrapper>

              {ellipsis && (
                <ReadMore
                  onClick={() => {
                    setEllipsis(false);
                  }}
                >
                  全て表示
                </ReadMore>
              )}
            </>
          )
        : isMaskedInterviewMemo && (
            <>
              <AdminWrapper>
                <AdminAvatar src={Assets.admin_image} />
                <div>
                  <AdminUpdateParagraph bold={true}>
                    {customer.getInterviewUpdatedAtString()} 更新
                  </AdminUpdateParagraph>
                  <Paragraph bold={true}>Libera担当者による面談情報</Paragraph>
                </div>
              </AdminWrapper>
              <AdminMemoWrapper>
                <MockParagraph src={Assets.dummy_paragraph} />
                <AbsoluteWrapper>
                  <ChangePlanInfoWrapper>
                    <ParagraphSup bold={true}>
                      エキスパート・パートナーによる面談クチコミ
                    </ParagraphSup>
                    <ParagraphSup>
                      こちらをご利用になるには、プランのアップグレードが必要になります。以下より、プランの変更申し込みをお願い致します。
                    </ParagraphSup>
                  </ChangePlanInfoWrapper>

                  <ButtonWrapper>
                    <BtnOuterLinkCorporateMiddle
                      href={OuterURL.planChangeFormURL}
                      target="_blank"
                      rel="noopener"
                    >
                      プランを変更する
                    </BtnOuterLinkCorporateMiddle>
                  </ButtonWrapper>
                </AbsoluteWrapper>
              </AdminMemoWrapper>
            </>
          )}
    </React.Fragment>
  );
};

export default CustomerInterviewMemoInfo;

const AdminWrapper = styled.div`
  display: flex;
  margin-bottom: 25px;
  margin-top: 55px;
`;

const AdminAvatar = styled(AvatarSmall)`
  width: 57px;
  height: 57px;
  margin-right: 15px;
`;

const AdminUpdateParagraph = styled(Paragraph)`
  color: ${ConstColor.Gray};
`;

const AdminMemoWrapper = styled.div`
  border-radius: ${ConstBorderRound.CornerRoundAll5};
  background: #f1f6f8;
  white-space: pre-wrap;
  position: relative;
`;

const AdminMemoPadding = styled.div`
  padding: 60px 45px 45px 45px;
`;

const MockParagraph = styled.img``;

const AbsoluteWrapper = styled.div`
  position: absolute;
  top: 270px;
  left: 55px;
  right: 55px;
`;

const ChangePlanInfoWrapper = styled.div`
  background: ${ConstColor.TableTh};
  border-radius: ${ConstBorderRound.CornerRoundAll};
  padding: 20px;
  margin-bottom: 10px;
`;

const ButtonWrapper = styled.div`
  margin: auto;
  width: fit-content;
`;

const ReadMore = styled.div`
  width: 130px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin: 18px auto;
  background-color: #eeeeee;
  border-radius: 30px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/template/customer_meta/customer_interview_memo_info.tsx